import React from 'react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useKatastrNemovitostiContextInstance } from '@gov-nx/module/page';
import {
	FormSearch,
	FormWidthElementLayout,
	HeaderLayout,
} from '@gov-nx/ui/web';

export interface CadastreOfRealEstateFilterProps {
	code: PageCode;
}

export const CadastreOfRealEstateFilter = ({
	code,
}: CadastreOfRealEstateFilterProps) => {
	const { t } = useLocale(code);
	const { formDefinition, onSubmit } = useKatastrNemovitostiContextInstance();

	return (
		<GovFormWeb
			formDefinition={formDefinition}
			onSubmit={onSubmit}>
			<HeaderLayout>
				<FormWidthElementLayout
					type="l"
					className="relative">
					<FormSearch
						input={{
							field: {
								name: 'search',
								placeholder: t('filtr.placeholder.vyhledat-nemovitost'),
							},
							label: {
								children: t('filtr.pole.wcag.vyhledat-nemovitost'),
							},
						}}
						button={{
							'aria-label': t('akce.wcag.vyhledat'),
						}}
					/>
				</FormWidthElementLayout>
			</HeaderLayout>
		</GovFormWeb>
	);
};
